/*!
 * @pixi/filter-kawase-blur - v2.7.0
 * Compiled Sun, 13 Jan 2019 22:51:52 UTC
 *
 * @pixi/filter-kawase-blur is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
import { Point as e, Filter as t } from "pixi.js";

var r = "attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n    vTextureCoord = aTextureCoord;\n}",
    i = "\nvarying vec2 vTextureCoord;\nuniform sampler2D uSampler;\n\nuniform vec2 uOffset;\n\nvoid main(void)\n{\n    vec4 color = vec4(0.0);\n\n    // Sample top left pixel\n    color += texture2D(uSampler, vec2(vTextureCoord.x - uOffset.x, vTextureCoord.y + uOffset.y));\n\n    // Sample top right pixel\n    color += texture2D(uSampler, vec2(vTextureCoord.x + uOffset.x, vTextureCoord.y + uOffset.y));\n\n    // Sample bottom right pixel\n    color += texture2D(uSampler, vec2(vTextureCoord.x + uOffset.x, vTextureCoord.y - uOffset.y));\n\n    // Sample bottom left pixel\n    color += texture2D(uSampler, vec2(vTextureCoord.x - uOffset.x, vTextureCoord.y - uOffset.y));\n\n    // Average\n    color *= 0.25;\n\n    gl_FragColor = color;\n}",
    o = "\nvarying vec2 vTextureCoord;\nuniform sampler2D uSampler;\n\nuniform vec2 uOffset;\nuniform vec4 filterClamp;\n\nvoid main(void)\n{\n    vec4 color = vec4(0.0);\n\n    // Sample top left pixel\n    color += texture2D(uSampler, clamp(vec2(vTextureCoord.x - uOffset.x, vTextureCoord.y + uOffset.y), filterClamp.xy, filterClamp.zw));\n\n    // Sample top right pixel\n    color += texture2D(uSampler, clamp(vec2(vTextureCoord.x + uOffset.x, vTextureCoord.y + uOffset.y), filterClamp.xy, filterClamp.zw));\n\n    // Sample bottom right pixel\n    color += texture2D(uSampler, clamp(vec2(vTextureCoord.x + uOffset.x, vTextureCoord.y - uOffset.y), filterClamp.xy, filterClamp.zw));\n\n    // Sample bottom left pixel\n    color += texture2D(uSampler, clamp(vec2(vTextureCoord.x - uOffset.x, vTextureCoord.y - uOffset.y), filterClamp.xy, filterClamp.zw));\n\n    // Average\n    color *= 0.25;\n\n    gl_FragColor = color;\n}\n",
    n = function (t) {
  function n(n, l, u) {
    void 0 === n && (n = 4), void 0 === l && (l = 3), void 0 === u && (u = !1), t.call(this, r, u ? o : i), this.uniforms.uOffset = new Float32Array(2), this._pixelSize = new e(), this.pixelSize = 1, this._clamp = u, this._kernels = null, Array.isArray(n) ? this.kernels = n : (this._blur = n, this.quality = l);
  }

  t && (n.__proto__ = t), n.prototype = Object.create(t && t.prototype), n.prototype.constructor = n;
  var l = {
    kernels: {
      configurable: !0
    },
    clamp: {
      configurable: !0
    },
    pixelSize: {
      configurable: !0
    },
    quality: {
      configurable: !0
    },
    blur: {
      configurable: !0
    }
  };
  return n.prototype.apply = function (e, t, r, i) {
    var o,
        n = this.pixelSize.x / t.size.width,
        l = this.pixelSize.y / t.size.height;
    if (1 === this._quality || 0 === this._blur) o = this._kernels[0] + .5, this.uniforms.uOffset[0] = o * n, this.uniforms.uOffset[1] = o * l, e.applyFilter(this, t, r, i);else {
      for (var u, s = e.getRenderTarget(!0), a = t, f = s, p = this._quality - 1, x = 0; x < p; x++) {
        o = this._kernels[x] + .5, this.uniforms.uOffset[0] = o * n, this.uniforms.uOffset[1] = o * l, e.applyFilter(this, a, f, !0), u = a, a = f, f = u;
      }

      o = this._kernels[p] + .5, this.uniforms.uOffset[0] = o * n, this.uniforms.uOffset[1] = o * l, e.applyFilter(this, a, r, i), e.returnRenderTarget(s);
    }
  }, n.prototype._generateKernels = function () {
    var e = this._blur,
        t = this._quality,
        r = [e];
    if (e > 0) for (var i = e, o = e / t, n = 1; n < t; n++) {
      i -= o, r.push(i);
    }
    this._kernels = r;
  }, l.kernels.get = function () {
    return this._kernels;
  }, l.kernels.set = function (e) {
    Array.isArray(e) && e.length > 0 ? (this._kernels = e, this._quality = e.length, this._blur = Math.max.apply(Math, e)) : (this._kernels = [0], this._quality = 1);
  }, l.clamp.get = function () {
    return this._clamp;
  }, l.pixelSize.set = function (t) {
    "number" == typeof t ? (this._pixelSize.x = t, this._pixelSize.y = t) : Array.isArray(t) ? (this._pixelSize.x = t[0], this._pixelSize.y = t[1]) : t instanceof e ? (this._pixelSize.x = t.x, this._pixelSize.y = t.y) : (this._pixelSize.x = 1, this._pixelSize.y = 1);
  }, l.pixelSize.get = function () {
    return this._pixelSize;
  }, l.quality.get = function () {
    return this._quality;
  }, l.quality.set = function (e) {
    this._quality = Math.max(1, Math.round(e)), this._generateKernels();
  }, l.blur.get = function () {
    return this._blur;
  }, l.blur.set = function (e) {
    this._blur = e, this._generateKernels();
  }, Object.defineProperties(n.prototype, l), n;
}(t);

export { n as KawaseBlurFilter };